export default __webpack_public_path__ + "static/media/Novelties_Disable.4eba5511.svg";